"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCancelPurchaseOrderService = exports.useUpdatePurchaseOrderService = exports.useCreatePurchaseOrderService = exports.useFetchPurchaseOrderService = void 0;
const AuthGuard_1 = require("../../components/tsComponents/AuthGuard");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const purchaseOrderServiceAction_1 = require("./purchaseOrderServiceAction");
const useFetchPurchaseOrderService = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const fetchPurchaseOrderServiceLoading = (0, react_redux_1.useSelector)((state) => state['subscriptionPurchaseOrderService/fetch'].loading);
    const fetchPurchaseOrderServiceError = (0, react_redux_1.useSelector)((state) => state['subscriptionPurchaseOrderService/fetch'].error);
    const fetchPurchaseOrderServiceData = (0, react_redux_1.useSelector)((state) => state['subscriptionPurchaseOrderService/fetch'].data);
    const fetchLastSuccessPurchaseOrderServiceData = (0, react_redux_1.useSelector)((state) => state['subscriptionPurchaseOrderService/fetchLastSuccess'].data);
    const fetchPendingPurchaseOrderServiceData = (0, react_redux_1.useSelector)((state) => state['subscriptionPurchaseOrderService/fetchPending'].data);
    const fetchPurchaseOrderService = (payload) => __awaiter(void 0, void 0, void 0, function* () {
        let userLogged = yield (0, AuthGuard_1.isLoggedIn)();
        if (!userLogged) {
            history('/auth/sign-in');
            return;
        }
        yield dispatch((0, purchaseOrderServiceAction_1.fetch)(payload));
    });
    const fetchLastSuccessPurchaseOrderService = (payload) => __awaiter(void 0, void 0, void 0, function* () {
        let userLogged = yield (0, AuthGuard_1.isLoggedIn)();
        if (!userLogged) {
            history('/auth/sign-in');
            return;
        }
        yield dispatch((0, purchaseOrderServiceAction_1.fetchLastSuccess)(payload));
    });
    const fetchPendingPurchaseOrderService = (payload) => __awaiter(void 0, void 0, void 0, function* () {
        let userLogged = yield (0, AuthGuard_1.isLoggedIn)();
        if (!userLogged) {
            history('/auth/sign-in');
            return;
        }
        yield dispatch((0, purchaseOrderServiceAction_1.fetchPending)(payload));
    });
    return {
        fetchPurchaseOrderServiceLoading,
        fetchPurchaseOrderServiceError,
        fetchPurchaseOrderServiceData,
        fetchPurchaseOrderService,
        fetchLastSuccessPurchaseOrderService,
        fetchPendingPurchaseOrderService,
        fetchLastSuccessPurchaseOrderServiceData,
        fetchPendingPurchaseOrderServiceData
    };
};
exports.useFetchPurchaseOrderService = useFetchPurchaseOrderService;
const useCreatePurchaseOrderService = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const createPurchaseOrderServiceLoading = (0, react_redux_1.useSelector)((state) => state['subscriptionPurchaseOrderService/create'].loading);
    const createPurchaseOrderServiceError = (0, react_redux_1.useSelector)((state) => state['subscriptionPurchaseOrderService/create'].error);
    const createPurchaseOrderServiceData = (0, react_redux_1.useSelector)((state) => state['subscriptionPurchaseOrderService/create'].data);
    const createPurchaseOrderService = (payload, onComplete) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            let userLogged = yield (0, AuthGuard_1.isLoggedIn)();
            if (!userLogged) {
                history('/auth/sign-in');
                return;
            }
            const res = yield dispatch((0, purchaseOrderServiceAction_1.create)(payload));
            if (res.meta.requestStatus === 'fulfilled') {
                onComplete(true, false, res.payload);
            }
            else if (res.meta.requestStatus === 'rejected') {
                throw new Error("Error while creating subscription purchase order service");
            }
        }
        catch (error) {
            onComplete(false, true, error.message);
        }
    });
    return {
        createPurchaseOrderServiceLoading,
        createPurchaseOrderServiceError,
        createPurchaseOrderServiceData,
        createPurchaseOrderService
    };
};
exports.useCreatePurchaseOrderService = useCreatePurchaseOrderService;
const useUpdatePurchaseOrderService = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const updatePurchaseOrderServiceLoading = (0, react_redux_1.useSelector)((state) => state['subscriptionPurchaseOrderService/update'].loading);
    const updatePurchaseOrderServiceError = (0, react_redux_1.useSelector)((state) => state['subscriptionPurchaseOrderService/update'].error);
    const updatePurchaseOrderServiceData = (0, react_redux_1.useSelector)((state) => state['subscriptionPurchaseOrderService/update'].data);
    const updatePurchaseOrderService = (payload, onComplete) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            let userLogged = yield (0, AuthGuard_1.isLoggedIn)();
            if (!userLogged) {
                history('/auth/sign-in');
                return;
            }
            const res = yield dispatch((0, purchaseOrderServiceAction_1.update)(payload));
            if (res.meta.requestStatus === 'fulfilled') {
                onComplete(true, false, res.payload);
            }
            else if (res.meta.requestStatus === 'rejected') {
                throw new Error("Error while updating subscription purchase order service");
            }
        }
        catch (error) {
            onComplete(false, true, error.message);
        }
    });
    return {
        updatePurchaseOrderServiceLoading,
        updatePurchaseOrderServiceError,
        updatePurchaseOrderServiceData,
        updatePurchaseOrderService
    };
};
exports.useUpdatePurchaseOrderService = useUpdatePurchaseOrderService;
const useCancelPurchaseOrderService = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const cancelPurchaseOrderServiceLoading = (0, react_redux_1.useSelector)((state) => state['subscriptionPurchaseOrderService/cancel'].loading);
    const cancelPurchaseOrderServiceError = (0, react_redux_1.useSelector)((state) => state['subscriptionPurchaseOrderService/cancel'].error);
    const cancelPurchaseOrderServiceData = (0, react_redux_1.useSelector)((state) => state['subscriptionPurchaseOrderService/cancel'].data);
    const cancelPurchaseOrderService = (onComplete) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            let userLogged = yield (0, AuthGuard_1.isLoggedIn)();
            if (!userLogged) {
                history('/auth/sign-in');
                return;
            }
            const res = yield dispatch((0, purchaseOrderServiceAction_1.cancel)());
            if (res.meta.requestStatus === 'fulfilled') {
                onComplete(true, false, res.payload);
            }
            else if (res.meta.requestStatus === 'rejected') {
                throw new Error("Error while cancelling subscription purchase order service");
            }
        }
        catch (error) {
            onComplete(false, true, error.message);
        }
    });
    return {
        cancelPurchaseOrderServiceLoading,
        cancelPurchaseOrderServiceError,
        cancelPurchaseOrderServiceData,
        cancelPurchaseOrderService
    };
};
exports.useCancelPurchaseOrderService = useCancelPurchaseOrderService;
